import { render, staticRenderFns } from "./pushJournal.vue?vue&type=template&id=fa5806a2&scoped=true&"
import script from "./pushJournal.vue?vue&type=script&lang=js&"
export * from "./pushJournal.vue?vue&type=script&lang=js&"
import style0 from "./pushJournal.vue?vue&type=style&index=0&id=fa5806a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa5806a2",
  null
  
)

export default component.exports